import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './../src/assets/fonts/Graphik/GraphikMedium.otf';
import './../src/assets/fonts/Graphik/GraphikBold.otf';
import './../src/assets/fonts/Graphik/GraphikSemibold.otf';
import './../src/assets/fonts/Graphik/GraphikRegular.otf';
import './../src/assets/fonts/OpenSans/OpenSans-Bold.woff';
import './../src/assets/fonts/OpenSans/OpenSans-Regular.woff';
import './../src/assets/fonts/OpenSans/OpenSans-SemiBold.woff';

import './../src/assets/css/MVPCommon.scss';
import './../src/assets/css/index.scss';
import './../src/assets/css/PlatesPage.scss';
import './../src/assets/css/customJsonEditor.scss';
import './../src/assets/css/common.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Provider } from 'react-redux';
import store, { persistor } from "./redux/store/store"; // Ensure your store exports persistor
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
